var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconScore348Line = function SvgIconScore348Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.699c-9.21 0-16.7-7.49-16.7-16.7 0-9.21 7.49-16.7 16.7-16.7 9.21 0 16.7 7.49 16.7 16.7 0 9.21-7.49 16.7-16.7 16.7Zm0-30c-7.33 0-13.3 5.97-13.3 13.3 0 7.33 5.97 13.3 13.3 13.3 7.33 0 13.3-5.97 13.3-13.3 0-7.33-5.97-13.3-13.3-13.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 22.899a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM18.5 22.899a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM24 33.599c-3.81 0-7.04-2.7-7.68-6.41l3.35-.57c.35 2.08 2.17 3.59 4.32 3.59 2.15 0 3.97-1.51 4.32-3.59l3.35.57c-.63 3.72-3.86 6.41-7.68 6.41H24Z",
    fill: "current"
  })));
};
export default SvgIconScore348Line;